<template>
  <section class="segment-records">
    <div class="segment-summary">共 {{ total }} 段 · 本页 {{ regularSegments.length }} 段 · 已隐藏 0 圈分段</div>
    <Table :size="size" :border="border" :columns="columns" :data="regularSegments" :loading="loading" :no-data-text="noDataText" />
  </section>
</template>

<script>
import segmentPresentation from './segment-presentation'

// Hide explicit zero counts only; unknown counts must remain visible.
const isZero = value => value === 0 || value === '0'

export default {
  name: 'SegmentTable',
  mixins: [segmentPresentation],
  props: {
    rows: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    noDataText: { type: String, default: '暂无已同步分段' },
    size: { type: String, default: 'default' },
    border: { type: Boolean, default: false }
  },
  computed: {
    regularSegments () { return this.rows.filter(row => !isZero(row.roundCount)) }
  }
}
</script>

<style scoped>
.segment-summary { margin-bottom: 10px; color: #808695; }
</style>
